import { Phone } from "lucide-react";
import { bedrijf } from "../data/content";

export const MobileCallButton = () => {
  return (
    <a
      data-testid="mobile-sticky-call-button"
      href={`tel:${bedrijf.telefoonRaw}`}
      className="md:hidden fixed bottom-5 inset-x-4 z-50 flex items-center justify-center gap-2 bg-primary text-primary-foreground font-semibold rounded-full px-6 py-4 shadow-lg shadow-primary/30"
    >
      <Phone size={20} /> Bel direct — {bedrijf.telefoon}
    </a>
  );
};
